module.exports = __webpack_public_path__ + "static/6Sigma_MetaisBasicos-c936cd3a5fe210f3b258e6209c47fd63.jpg";